import * as React from "react";

const styles = require('./AsOfDataCell.pcss');

interface LProps{
    key?: number;
    dataPoint?: any;
}

export class AsOfDataCell extends React.Component<LProps, {}>{
    constructor(){
        super();
    }

    render(){
        return(
            <td className={styles.dataCell} colSpan={1}>  { this.props.dataPoint } </td>
        );
    }
}



// WEBPACK FOOTER //
// ./src/client/Rankia/Components/AsOfDataCell/AsOfDataCell.tsx